import { SourcingService } from 'api-clients/monolith';

import type { OptionalFieldValues } from './types';

type CreateVonqContractPayload = Parameters<
  typeof SourcingService.postInternalApiSourcingVonqContractsNew
>[0];

export function buildOptionalRequestFields(
  values: OptionalFieldValues,
): Partial<CreateVonqContractPayload> {
  const optional: Partial<CreateVonqContractPayload> = {};

  const alias = values.alias;
  if (alias) optional.alias = alias;

  const expiryDate = values.expiryDate;
  if (expiryDate) optional.expiry_date = expiryDate;

  const currency = values.currency ?? '';
  if (currency) optional.currency = currency;

  const amount = values.amount;
  if (amount) {
    const parsedAmount = Number(amount);
    if (!Number.isNaN(parsedAmount)) optional.amount = parsedAmount;
  }

  const credits = values.credits;
  if (credits) {
    const parsedCredits = Number(credits);
    if (!Number.isNaN(parsedCredits)) optional.credits = parsedCredits;
  }

  const postingDurationDays = values.postingDurationDays;
  if (postingDurationDays) {
    const parsedDays = Number.parseInt(postingDurationDays, 10);
    if (!Number.isNaN(parsedDays)) {
      optional.posting_duration_days = parsedDays;
    }
  }

  return optional;
}
